/**
 * Type of trade attribute defining a subgroup in an allocation group.
 * tag: 2980
 * @readonly
 * @enum {number} (int)
 */
export enum AllocGroupSubQtyType {
  /** Trade type */
  TradeType = 1,
  /** Trade publication indicator */
  TradePublicationIndicator = 2,
  /** Order handling instruction */
  OrderHandlingInstruction = 3,
}
